import { Zap, MessageSquareText, Palette, Layers, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { CTA_URL } from "../lib/constants";

const REASONS = [
    {
        icon: Zap,
        title: "Ship in minutes",
        copy: "From prompt to live product before your coffee cools — not in weeks of development.",
        testId: "why-ship-fast",
    },
    {
        icon: MessageSquareText,
        title: "Zero code, zero setup",
        copy: "Describe your idea in plain words. Emergent designs, builds, and wires everything up.",
        testId: "why-zero-code",
    },
    {
        icon: Palette,
        title: "Professional results",
        copy: "Modern, responsive UI that looks like a senior team built it — on every screen size.",
        testId: "why-professional",
    },
    {
        icon: Layers,
        title: "Grows with you",
        copy: "Websites, web apps, dashboards, internal tools — change anything just by asking.",
        testId: "why-grows",
    },
];

export const WhyChoose = () => (
    <section id="why-emergent" data-testid="why-emergent-section" className="px-6 py-20 sm:py-28">
        <div className="mx-auto max-w-6xl">
            <Reveal className="mb-12 text-center sm:mb-14">
                <Eyebrow>Why Emergent</Eyebrow>
                <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-white sm:text-5xl">
                    Why build with Emergent?
                </h2>
                <p className="mx-auto mt-4 max-w-xl text-base text-white/60 sm:text-lg">
                    The fastest way from idea to live product — here's what you get.
                </p>
            </Reveal>

            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {REASONS.map((reason, i) => (
                    <Reveal key={reason.title} delay={i * 0.08}>
                        <div
                            data-testid={reason.testId}
                            className="group h-full rounded-2xl border border-white/10 bg-[#0A0A0A] p-7 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-white/20 hover:shadow-[0_0_40px_rgba(0,194,255,0.1)]"
                        >
                            <span className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-[#8B5CF6] transition-colors duration-300 group-hover:text-[#00C2FF]">
                                <reason.icon size={20} strokeWidth={1.5} />
                            </span>
                            <h3 className="font-display text-lg font-medium text-white">{reason.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-white/55">{reason.copy}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2} className="mt-10 text-center">
                <a
                    href={CTA_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="why-cta-link"
                    className="group inline-flex items-center gap-2 text-base font-medium text-[#00C2FF] transition-colors duration-200 hover:text-white"
                >
                    Start building free
                    <ArrowRight size={17} className="transition-transform duration-200 group-hover:translate-x-1" />
                </a>
            </Reveal>
        </div>
    </section>
);
